import React, { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useKioskMode } from '../../contexts/KioskModeContext';
import { kioskConfirmationPath } from './kioskPaths';

/**
 * After hosted checkout, takeaway kiosk guests may land on order details with `?payment=SUCCESS`.
 * Send them to the queue token screen. Table dine-in kiosks stay on order details.
 */
const KioskPaymentReturnRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { role: kioskRole } = useKioskMode();

  useLayoutEffect(() => {
    if (kioskRole === 'TABLE_KIOSK') {
      return;
    }
    const match = location.pathname.match(/^\/kiosk\/([^/]+)\/orders\/([^/]+)$/);
    if (!match) {
      return;
    }
    const payment = new URLSearchParams(location.search).get('payment')?.toUpperCase();
    if (payment !== 'SUCCESS' && payment !== 'PAID') {
      return;
    }
    const appName = decodeURIComponent(match[1]);
    const orderId = decodeURIComponent(match[2]);
    const params = new URLSearchParams(location.search);
    params.set('orderId', orderId);
    if (!params.get('payment')) {
      params.set('payment', 'SUCCESS');
    }
    navigate(`${kioskConfirmationPath(appName)}?${params.toString()}`, { replace: true });
  }, [kioskRole, location.pathname, location.search, navigate]);

  return null;
};

export default KioskPaymentReturnRedirect;
